import React, { useState } from "react";
import ListGroup from "../../components/ListGroup";
import { View } from "react-native";
import { getAvatarUrl } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";
import { BodySmallText } from "../../components/FormattedText";

function ListItemStoryComponent() {
    const [value, setValue] = useState("1");

    return (
        <View style={{ padding: 0, alignSelf: "stretch" }}>
            <ListGroup<string>
                value={value}
                onPressItem={setValue}
                items={[
                    {
                        title: "One",
                        value: "1",
                    },
                    {
                        title: "Two",
                        value: "2",
                    },
                    {
                        title: "With icon",
                        icon: "talent",
                        value: "4",
                    },
                    {
                        title: "With avatar",
                        avatarPath: getAvatarUrl(),
                        value: "5",
                    },
                    {
                        title: "Big with icon",
                        icon: "talent",
                        useBigAvatarOrIcon: true,
                        value: "6",
                    },
                    {
                        title: "Big with avatar",
                        avatarPath: getAvatarUrl(),
                        useBigAvatarOrIcon: true,
                        value: "7",
                    },
                    {
                        title: "Rich item",
                        description: "With a description",
                        tags: ["one", "two", "three"],
                        value: "8",
                        badge: <BodySmallText>Badge</BodySmallText>,
                    },
                    {
                        title: "Call to action",
                        rightActionMode: "action",
                        rightIcon: "arrow-right",
                        value: "9",
                    },
                ]}
            />
        </View>
    );
}

const meta = {
    title: "Atom/ListGroup",
    component: ListItemStoryComponent,
    argTypes: {},
    parameters: {
        sherlo: {
            exclude: false,
        },
    },
} satisfies Meta<typeof ListItemStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
